// extracted by mini-css-extract-plugin
export var measureBox = "_c2-0";